// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--mp-bniFj","close-button":"close-button--mp-N4lSf","closeButton":"close-button--mp-N4lSf"};